<template>
    <hts-drawer
        v-model="visible"
        :custom="['header', 'footer']"
        :title="$t('labels.addDocument')"
        :submit="visibleDocument"
        :rules="rules.addDocumentVehicle"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="resetField()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-select
                    v-model="dataFormAddDocument.type"
                    :label="$t('labels.documentType')"
                    required
                    :items="listTypeDocument"
                    key-id="key"
                    key-label="value"
                    :color="color"
                    name="documentType"
                    prop="documentType" />
                <hts-form-input
                    v-model="dataFormAddDocument.fileName"
                    :label="$t('labels.documentFileName')"
                    :color="color"
                    name="documentFileName"
                    prop="documentFileName" />
                <hts-form-input
                    v-if="dataFormAddDocument.type === listTypeDocument[0].key"
                    v-model="dataFormAddDocument.insurancePrice"
                    :label="$t('labels.insurancePrice')"
                    :color="color"
                    required
                    type="number"
                    name="insurancePrice"
                    prop="insurancePrice" />
                <hts-form-date
                    v-if="dataFormAddDocument.type === listTypeDocument[0].key"
                    v-model="dataFormAddDocument.expiredDate"
                    required
                    :label="$t('labels.expiredDate')"
                    :color="props.color"
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-file
                    ref="file"
                    v-model="fileDocument"
                    :required="true"
                    type="file"
                    :label="$t('labels.document')"
                    name="document"
                    prop="document" />
                <hts-form-date
                    v-if="dataFormAddDocument.type === listTypeDocument[1].key"
                    v-model="dataFormAddDocument.expiredDate"
                    required
                    :label="$t('labels.expiredDate')"
                    :color="props.color"
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-input
                    v-model="dataFormAddDocument.description"
                    :label="$t('labels.description')"
                    :color="color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>

        <hts-modal
            :show="showConfirmAddDocument"
            :title="$t('labels.confirmCreateDocument')"
            type="confirm"
            :content="$t('labels.contentConfirmExpiredDateDocument')"
            @hide="showConfirmAddDocument = false"
            @confirm="handleSubmitFormAddDocument" />
    </hts-drawer>
</template>

<script lang="ts" setup>
import form from '../imports/form'
const { rules } = form

const showConfirmAddDocument = ref(false)

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  type: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['refreshTables'])

const reMoocID = ref()

const dataFormAddDocument = ref({
  fileName: '',
  type: '',
  description: '',
  expiredDate: null,
  insurancePrice: null
})
const fileDocument = ref<File | string>('')

const visible = ref(false)
const openAddDocument = (id: string) => {
  visible.value = true
  reMoocID.value = id
}
defineExpose({
  openAddDocument
})

const resetField = () => {
  dataFormAddDocument.value = {
    fileName: '',
    type: '',
    description: '',
    expiredDate: null,
    insurancePrice: null
  }
  fileDocument.value = ''
}
const listTypeDocument = [
  {
    key: 'INSURANCE',
    value: $t('labels.vehicleModule.insurance')
  },
  {
    key: 'REGISTRY',
    value: $t('labels.registry')
  },
  {
    key: 'OTHER',
    value: $t('labels.other')
  }
]

const visibleDocument = async () => {
  if (
    dataFormAddDocument.value.expiredDate &&
    ['INSURANCE', 'REGISTRY'].includes(dataFormAddDocument.value.type) &&
    new Date(dataFormAddDocument.value.expiredDate + ' 23:59:59').getTime() < new Date().getTime()
  ) {
    showConfirmAddDocument.value = true
  } else {
    await handleSubmitFormAddDocument()
  }
}
const handleSubmitFormAddDocument = async () => {
  const dataForm = new FormData()
  dataForm.append('document', fileDocument.value)
  dataForm.append('fileName', dataFormAddDocument.value.fileName || '')
  dataForm.append('remooc', reMoocID.value)
  dataForm.append('type', dataFormAddDocument.value.type || '')
  dataForm.append('description', dataFormAddDocument.value.description || '')
  dataForm.append('expiredDate', dataFormAddDocument.value.expiredDate || '')
  dataForm.append('insurancePrice', JSON.stringify(dataFormAddDocument.value.insurancePrice))
  const api = {
    method: 'POST',
    url: '/vehicle/remooc-document/upload'
  }
  const data: any = await $api(api, { body: dataForm })
  const resData: any = data?.data?.value

  if (resData?.success) {
    process.client && $toast().success($t('notifications.addSuccessDocument'))
    visible.value = false
    showConfirmAddDocument.value = false
    resetField()
    emits('refreshTables')
  }
}

const closeOverSide = () => {
  visible.value = false
  resetField()
}
</script>
